import { useState } from "react";
import { toast } from "sonner";
import { CreditCard, Smartphone } from "lucide-react";
import { api, errMsg, fmtCard } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Field } from "@/components/AuthLayout";
import { WagerInfo } from "./WagerInfo";

const METHODS = [
  { id: "m10", label: "m10", Icon: Smartphone, hint: "m10 hesabına bağlı telefon nömrəsi", ph: "+994 50 000 00 00" },
  { id: "card", label: "Bank kartı", Icon: CreditCard, hint: "16 rəqəmli kart nömrəsi", ph: "0000 0000 0000 0000" },
];

export const WithdrawForm = ({ info, onDone }) => {
  const { user } = useAuth();
  const [method, setMethod] = useState("m10");
  const [amount, setAmount] = useState("25");
  const [account, setAccount] = useState("");
  const [loading, setLoading] = useState(false);
  const m = METHODS.find((x) => x.id === method);

  const submit = async (e) => {
    e.preventDefault();
    if (Number(amount) < info.min_withdraw) return toast.error(`Minimum çıxarış ${info.min_withdraw} AZN-dir`);
    if (Number(amount) > info.max_withdraw) return toast.error(`Maksimum çıxarış ${info.max_withdraw} AZN-dir`);
    if (Number(amount) > user.balance) return toast.error("Balans kifayət etmir");
    setLoading(true);
    try {
      await api.post("/wallet/withdraw", { amount: Number(amount), method, account });
      toast.success("Çıxarış sorğusu göndərildi");
      setAccount("");
      onDone();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form noValidate onSubmit={submit} className="max-w-2xl rounded-3xl border border-white/10 bg-[#111] p-8 space-y-6" data-testid="withdraw-form">
      <div className="grid grid-cols-2 gap-4">
        {METHODS.map(({ id, label, Icon }) => (
          <button type="button" key={id} onClick={() => { setMethod(id); setAccount(""); }}
            className={`rounded-2xl border p-5 flex items-center gap-3 transition-colors ${method === id ? "border-[#D4AF37] bg-[#D4AF37]/10" : "border-white/10 hover:border-white/30"}`}
            data-testid={`withdraw-method-${id}`}>
            <Icon className="text-[#D4AF37]" /> <span className="font-display font-semibold">{label}</span>
          </button>
        ))}
      </div>
      <Field label={m.hint} required value={account} placeholder={m.ph} inputMode="numeric"
        onChange={(e) => setAccount(method === "card" ? fmtCard(e.target.value) : e.target.value.replace(/[^\d+ ]/g, ""))} data-testid="withdraw-account-input" />
      <Field label={`Məbləğ (min. ${info.min_withdraw} ₼ · maks. ${info.max_withdraw} ₼)`} type="number" required min={info.min_withdraw} step="0.01" value={amount} onChange={(e) => setAmount(e.target.value)} data-testid="withdraw-amount-input" />
      <WagerInfo info={info} key={user.balance} />
      <button disabled={loading} className="btn-gold w-full rounded-full py-4 font-display font-bold" data-testid="withdraw-submit-btn">{loading ? "Göndərilir..." : "Çıxarış et"}</button>
    </form>
  );
};
